// extracted by mini-css-extract-plugin
export default {"container":"listening_container__Bkd0v","newQuizzesContainer":"listening_newQuizzesContainer__Mk6rr","textDraw":"listening_textDraw__8gtz7"};